

































































import { Prop, Component, Vue, Watch } from 'vue-property-decorator'
import { State, Getter, Action, Mutation, namespace } from 'vuex-class'
import { NewPage } from '@/model/common/newPage'
import { TableAccount } from '@/apps/addressbook/model/TableAccount'
import { Permission } from '@/model/permission/permission'
import RoleSelector from '@/components/bizComponents/RolesSelector.vue'
import { Pagination, Divider, Popconfirm } from 'ant-design-vue'

import {
  batchAdd,
  PagePermissionAccountParam,
  removePermissionAccount,
  removePermissionAccounts
} from '@/api/permission/permission'
import { Account, fetchAccountWithoutRedirect } from 'ykd-base/account'
import { message } from 'ant-design-vue'
import { Role } from '@/model/role/role'
import { addRolesPermission, romovePermissions } from '@/api/role/role'
const PermissionStore = namespace('app-addressbook/permission')
interface Paging {
  pageSize?: number
  current?: number
  total?: number
}
@Component({
  components: { RoleSelector, 'a-popconfirm': Popconfirm }
})
export default class YkdPermissionRole extends Vue {
  @PermissionStore.Mutation('setPermission') setPermission!: Function
  @PermissionStore.Action('getPageAccount') getPageAccount!: Function
  @PermissionStore.Action('getPermissions') getPermissions!: Function
  @PermissionStore.Action('getRoles') getRoles!: Function

  @PermissionStore.State('permissions') permissions!: Permission[]
  @PermissionStore.State('roles') roles!: Role[]

  @PermissionStore.State('selectedPermission') selectedPermission!: Permission
  @PermissionStore.State('accountPageDate') accountPageDate!: NewPage<
    TableAccount
  >

  private saveDraw = false
  private clickIndex: number = 0
  private deleteDiabled: boolean = true
  private orgDrawer: boolean = false
  private account: any = {}
  private memberTableLoading: boolean = false
  private selectedRoleKeys: string[] = []
  private pagination: Paging = {
    pageSize: 10,
    current: 1,
    total: 0
  }

  private columns: any = [
    {
      title: '角色标题',
      dataIndex: 'title',
      key: 'title'
    },
    {
      title: '角色名称',
      dataIndex: 'name',
      key: 'name'
    },
    {
      title: '类型',
      key: 'typeName',
      dataIndex: 'typeName'
    },
    {
      title: '备注',
      key: 'remark',
      dataIndex: 'remark'
    },
    {
      title: '操作',
      key: 'action',
      scopedSlots: { customRender: 'action' }
    }
  ]

  @Watch('selectedPermission')
  async queryRoles() {
    this.memberTableLoading = true
    await this.getRoles(this.selectedPermission.id!)
    this.memberTableLoading = false
  }

  @Watch('selectedRoleKeys')
  selectedRowKeyChange() {
    if (this.selectedRoleKeys && this.selectedRoleKeys.length > 0) {
      this.deleteDiabled = false
    } else {
      this.deleteDiabled = true
    }
  }

  async getTableData(param: PagePermissionAccountParam) {
    this.memberTableLoading = true
    await this.getRoles(param)
    this.memberTableLoading = false
  }

  rightDrawClose() {
    this.saveDraw = false
  }

  async mounted() {
    await this.initPermissions()
    this.account = await fetchAccountWithoutRedirect()
  }

  async initPermissions() {
    this.pagination = {
      pageSize: 10,
      current: 1,
      total: 0
    }

    await this.queryRoles()
    this.pagination.total = this.roles.length
  }

  closeOrgCenter() {
    this.orgDrawer = false
  }

  openOrgCenter() {
    this.orgDrawer = true
  }

  async confirmSelect(selectedRoles: Role[]) {
    if (selectedRoles && selectedRoles.length > 0) {
      const roleIds: string[] = selectedRoles.map(role => role.id!)

      const result = await addRolesPermission(
        roleIds,
        this.selectedPermission.id!
      )

      if (result) {
        message.success('添加角色权限成功')
        await this.initPermissions()
      } else {
        message.error('添加角色权限失败')
      }
    }
  }

  async handleTableChange(pagination: Paging) {
    this.pagination = pagination
  }

  onSelectChange(selectedRoleKeys: string[]) {
    this.selectedRoleKeys = selectedRoleKeys
  }

  async removePermission(record: any) {
    const result = await romovePermissions(this.selectedPermission.id!, [
      record.id
    ])

    if (result) {
      this.refreshRole(1)
      message.success('移除权限成功')
    } else {
      message.error('移除权限失败')
    }
  }

  async batchDelete() {
    if (this.selectedRoleKeys.length < 1) {
      message.warn('请选择成员再操作')

      return
    }
    const result = await romovePermissions(
      this.selectedPermission.id!,
      this.selectedRoleKeys
    )

    if (result) {
      this.refreshRole(this.selectedRoleKeys.length)
      message.success('移除权限成功')
    } else {
      message.error('移除权限失败')
    }
  }

  async refreshRole(delNum: number) {
    if (delNum > 1) {
      this.selectedRoleKeys = []
      await this.initPermissions()
      return
    }
    if (this.roles && this.roles.length == 1 && this.pagination != 0) {
      this.pagination = {
        current: this.pagination.current! - 1,
        pageSize: this.pagination.pageSize,
        total: this.pagination.total
      }
    }
    await this.queryRoles()
  }
}
